import React from 'react';
import styled from 'styled-components';

export default function ({ org }) {
  return (
    <Wrapper>
      <Title>これまでの実績</Title>
      <Text>{org.performance}</Text>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
`;

const Title = styled.div`
  margin-top: 5px;
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #2c2c2c;
`;

const Text = styled.div`
  padding: 20px 35px 40px;
  font-size: 18px;
  line-height: 40px;
  white-space: pre-wrap;
`;
